import type { ReplayReactionEvent } from '../../shared/replayReactionEvent';
import { requestJson } from './requestJson';

// Server-gated on finished_at (spec §6.3). This function must only ever be
// called from the summary screen — never speculatively, never prefetched on the
// watch screen. Acceptance criterion 9 checks the network tab, not just the UI,
// precisely because a well-meaning prefetch would satisfy the visible product
// while quietly destroying the dataset.
export async function getReviewerReplayStream(reviewerId: string): Promise<ReplayReactionEvent[]> {
  return await requestJson(`/api/reviewers/${encodeURIComponent(reviewerId)}/replay`);
}
